<div class="update-offer">
  <div class="flex align-items-center justify-content-center p-4" *ngIf="loading">
    <p-progressSpinner styleClass="w-3rem h-3rem"></p-progressSpinner>
  </div>

  <div class="p-error mb-3" *ngIf="loadError">{{ loadError }}</div>

  <div *ngIf="!loading && diffs.length > 0" class="grid">
    <div class="col-12">
      <p-tag severity="info" value="Дані з листа відрізняються від збережених"></p-tag>
    </div>

    <!-- Diff rows -->
    <div class="col-12">
      <div class="diff-table">
        <div class="diff-header">
          <div class="diff-field">Поле</div>
          <div class="diff-current">Теперішнє значення</div>
          <div class="diff-extracted">Значення з листа</div>
          <div class="diff-checkbox"></div>
        </div>

        <div class="diff-row" *ngFor="let diff of diffs">
          <div class="diff-field font-bold">{{ diff.label }}</div>
          <div class="diff-current">{{ diff.currentValue || '(не заповнено)' }}</div>
          <div class="diff-extracted">{{ diff.extractedValue }}</div>
          <div class="diff-checkbox">
            <p-checkbox [(ngModel)]="diff.checked" [binary]="true"></p-checkbox>
          </div>
        </div>
      </div>
    </div>

    <!-- Save button -->
    <div class="col-12 mt-3">
      <p-button label="Оновити обране" [disabled]="!hasCheckedDiffs || saving" [loading]="saving"
                (onClick)="onSave()"></p-button>
    </div>

    <small class="col-12 text-500 mt-2">
      Виберіть поля для оновлення. Будуть оновлені тільки позначені поля.
    </small>
  </div>

  <div *ngIf="!loading && diffs.length === 0 && !loadError" class="text-500">
    Дані відповідають раніше збереженим.
  </div>
</div>
